const key = 'URLSearchParams'

export const isEuropeanSite = ['https://telefonica.egg.live', 'https://formaciondixital.egg.live/'].includes(window?.location?.origin ?? '')

export const decodeSearchParams = <T = Record<string, string>>(searchParams: any): T => {
    return [...searchParams.entries()].reduce((acc, [key, val]) => {
        try {
            return {
                ...acc,
                [key]: JSON.parse(val),
            }
        } catch {
            return {
                ...acc,
                [key]: val,
            }
        }
    }, {})
}

export const persistUrlParameters = () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const searchParams = decodeSearchParams(urlParams)
    persistOnSession(searchParams)
}

export const persistOnSession = (params: Params) => sessionStorage.setItem(key, JSON.stringify(params))

export const updateSessionParams = (params: Params) => persistOnSession({ ...getUrlParameters(), ...params })

export const getUrlParameters = () => {
    try {
        const params = sessionStorage.getItem(key)
        if (!params || !params.startsWith('{') || !params.endsWith('}')) return {} as Params
        return JSON.parse(params) as Params
    } catch (error) {
        console.log(error)
        return {} as Params
    }
}

type Params = Record<string, string | number | boolean | undefined>

/**
 * Hosts of Egg's own media CDN (Google Cloud Storage behind media*.egg.live,
 * EGG-3586). Matched exactly: any other *.egg.live host is not a media host.
 * All three are accepted in every environment so content copied between
 * environments keeps playing.
 */
const EGG_MEDIA_HOSTS = ['media.egg.live', 'media-demo.egg.live', 'media-dev.egg.live']

/**
 * Detect video files we host ourselves: Egg's media CDN (media*.egg.live) and the older
 * Amazon S3 / CloudFront ones, regardless of bucket name or region.
 * For S3 it matches virtual-hosted (bucket.s3.region.amazonaws.com, bucket.s3.amazonaws.com,
 * bucket.s3-region.amazonaws.com), path-style (s3.region.amazonaws.com/bucket) and
 * CloudFront (distribution.cloudfront.net) URLs.
 */
export const isHostedVideoUrl = (url: string): boolean => {
    try {
        const { hostname, pathname } = new URL(url)
        const isEggMediaHost = EGG_MEDIA_HOSTS.includes(hostname)
        const isS3Host = hostname.endsWith('.amazonaws.com') && /(^|\.)s3[.-]/.test(hostname)
        const isCloudFrontHost = hostname.endsWith('.cloudfront.net')
        return (isEggMediaHost || isS3Host || isCloudFrontHost) && /\.(mp4|webm|mov|m4v)$/i.test(pathname)
    } catch {
        return false
    }
}
